// Replacements for the vue2-filters helpers the templates use
export function currency (value, symbol = '$', decimals = 2) {
  const number = parseFloat(value)
  if (!isFinite(number) || (!number && number !== 0)) return ''
  const negative = number < 0 ? '-' : ''
  const fixed = Math.abs(number).toFixed(decimals)
  const [whole, fraction] = fixed.split('.')
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return negative + symbol + grouped + (fraction ? '.' + fraction : '')
}

export function toCurrency (value) {
  if (typeof value != 'number') {
    return value
  }
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(value)
}
